export const palette = {
    light: {
        neutral: {
            white: '#FFFFFF',
            25: '#FCFCFD',
            50: '#F9FAFB',
            100: '#F2F4F7',
            200: '#EAECF0',
            300: '#D0D5DD',
            400: '#98A2B3',
            500: '#667085',
            600: '#475467',
            700: '#344054',
            800: '#1D2939',
            900: '#101828',
            950: '#0C111D',
            black: '#000000'
        },
        primary: {
            25: '#FCFAFF',
            50: '#F9F5FF',
            100: '#F4EBFF',
            200: '#E9D7FE',
            300: '#D6BBFB',
            400: '#B692F6',
            500: '#9E77ED',
            600: '#7F56D9',
            700: '#6941C6',
            800: '#53389E',
            900: '#42307D',
            950: '#102A56'
        },
        secondary: {
            25: '#F0F9FF',
            50: '#F8F9FC',
            100: '#EAECF5',
            200: '#6A707E',
            300: '#464A53',
            400: '#717BBC',
            500: '#6A707E',
            600: '#026AA2',
            700: '#363F72',
            800: '#6A707E',
            900: '#464A53',
            950: '#102A56'
        },
        success: {
            25: '#F6FEF9',
            50: '#ECFDF3',
            100: '#D1FADF',
            200: '#A6F4C5',
            300: '#6CE9A6',
            400: '#32D583',
            500: '#12B76A',
            600: '#039855',
            700: '#027A48',
            800: '#05603A',
            900: '#054F31',
            950: '#053321'
        },
        danger: {
            25: '#FFFBFA',
            50: '#FEF3F2',
            100: '#FEE4E2',
            200: '#FECDCA',
            300: '#FDA29B',
            400: '#F97066',
            500: '#F04438',
            600: '#D92D20',
            700: '#B42318',
            800: '#912018',
            900: '#7A271A',
            950: '#55160C'
        },
        warning: {
            25: '#FFFCF5',
            50: '#FFFAEB',
            100: '#FEF0C7',
            200: '#FEDF89',
            300: '#FEC84B',
            400: '#FDB022',
            500: '#F79009',
            600: '#DC6803',
            700: '#B54708',
            800: '#93370D',
            900: '#7A2E0E',
            950: '#4E1D09'
        }
    }
    //we will support the dark mode documenting this one and adding the dark types to our style.d.ts
    /*dark: null*/
}
